
import { mapState } from "vuex";
import { getDialogSizeByViewport } from "@/utils/dialogResponsive";
import { trackLoginImpression } from '@/plugins/hwtag/events'

export default {
  name: "xfans-header",
  data() {
    const navLink = [
      {
        nameKey: "page.HOME",
        link: "/",
      },
      {
        nameKey: "page.GALLERY",
        link: "/gallery",
      },

      {
        nameKey: "page.EVENTS",
        link: "/events",
        entry: "av_bar",
      },
      {
        nameKey: "page.DISCUSSION",
        link: "/discussion",
      },
      {
        nameKey: "page.NEWS",
        link: "/new",
      },
      {
        nameKey: "page.COURSES",
        link: "/tutorial",
        entry: "av_bar",
      },
      {
        nameKey: "xcoins.XCOINS_SHOP",
        link: "/xcoins/exchange",
      },
    ]; //导航栏链接
    return {
      navLink,
      dialogWidth: "25%",
      drawer: false, //是否打开模态框
      direction: "ttb", //上自下弹出
      searchHistoryArr: [],
      isNavMobile: false, //移动端菜单栏
      publishContent: false, //发布的模态框
      isMobile: false, //是否是移动端
      avatarPopover: false, //头像弹出框
      checkList: [], //投诉多选框
      reportTextarea: "", //投诉内容
      isCheckIn: false, //是否签到了
      signOutDialogVisible: false, //退出登录模态框
      disableUserDialogVisible: false, //禁用用户提示框
      link: "", //当前页面链接
      messageInfo: [], //消息数
      inputFocus: false, //搜索输入框是否获取到了焦点
      recentSearch: [],
      loginDialogVisible: false, //登录模态框
      showFooter: false, //是否显示底部登录框
      showDrawer: false, //是否显示注册抽屉
      /** DialogPassportSwitch == '1' 时走站内弹窗登录；否则跳转总站 SSO */
      showNewLogin: false,
      /** NoPwdPassportSwitch == '1' 且未登录时允许免密入口（与新版弹窗登录开关独立） */
      showPasswordFree: false,
      siteConfig: {}, //站点配置
      isVerifyingLogin: false, //避免路由切换时并发校验登录
      visibleNavCount: navLink.length, //桌面端可见导航数量，默认全部展示
      navOverflowRaf: null,
      navResizeObserver: null,
      storeOpen: false, //商城站点下拉是否展开
      storeSiteData: [], //商城站点列表
    };
  },
  created() {
    if (process.client) {
      this.loginVerification();
    }
  },

 async fetch() {
    const res = await this.$global.siteConfig();
    if (res.code == 200) {
      this.$store.commit("SET_SITE_CONFIG", res.data.site_config || {});
    }
  },
  async mounted() {
    this.$fetch();
    // this.searchHistory()
    this.dialogSize();
    this.getMessageInfo();
    this.getRecentSearch();
    this.initNavOverflowObserver();
    this.scheduleUpdateNavOverflow();
    // this.$create({
    //   app_id: "xppen_cm",
    //   debug: true,
    //   disableReport: false,
    //   account_id: "N/A",
    //   website_id: "website_id",
    //   brand_website: "XPPen",
    //   website_type: 3,
    //   website_code: "",
    //   is_login: "0",
    //   business_channel: "独立站",
    // });
    // this.$setProperty('abc','12321321')

    await this.$googleSignin.init(this.handleGoogleCredential);
    if (!this.$cookies.get('SSOTOKEN')) {
      this.$googleSignin.prompt();
    }
    this.fetchStoreSiteData();
    if (process.client) {
      document.addEventListener("click", this.handleStoreDocumentClick);
    }
  },
  beforeDestroy() {
    if (process.client) {
      document.removeEventListener("click", this.handleStoreDocumentClick);
    }
    if (this.navOverflowRaf) {
      cancelAnimationFrame(this.navOverflowRaf);
      this.navOverflowRaf = null;
    }
    if (this.navResizeObserver) {
      this.navResizeObserver.disconnect();
      this.navResizeObserver = null;
    }
  },
  watch: {
    $route(n, d) {
      if (process.client) {
        this.isNavMobile = false;
        this.storeOpen = false;
        this.loginVerification();
        this.getRecentSearch();
      }
    },
    "$i18n.locale"() {
      this.fetchStoreSiteData();
      this.scheduleUpdateNavOverflow();
    },
    "$store.state.siteConfig": {
      immediate: true,
      handler(val) {
        if (!val || !Object.keys(val).length) return;
        this.siteConfig = val;
        this.applySiteConfigVisibility();
      },
    },
    "$store.state.isLogin"() {
      this.applySiteConfigVisibility();
      this.refreshHeaderPoints();
      this.scheduleUpdateNavOverflow();
    },
    "$store.state.authModalNonce"() {
      this.handleGlobalAuthRequest();
    },
    navLink: {
      deep: true,
      handler() {
        this.scheduleUpdateNavOverflow();
      },
    },
  },
  computed: {
    totalUnreadCount() {
      const messageInfo = this.$store.state.messageInfo;
      if (!Array.isArray(messageInfo) || messageInfo.length === 0) {
        return 0;
      }
      return messageInfo.reduce((sum, count) => sum + (Number(count) || 0), 0);
    },
    headerUserInfo() {
      return this.$store.state.userInfo?.userInfo || {};
    },
    headerUserValue() {
      return this.$store.state.userInfo?.user_value || {};
    },
    headerPointsDetail() {
      return this.$store.state.pointDetail || {};
    },
    headerAvatar() {
      return (
        this.headerUserInfo.user_thumb_compress ||
        this.headerUserInfo.user_face_url ||
        require("@/assets/image/global/default-avatar.png")
      );
    },
    visibleNavLinks() {
      return this.navLink.slice(0, this.visibleNavCount);
    },
    overflowNavLinks() {
      return this.navLink.slice(this.visibleNavCount);
    },
  },
  methods: {
    getNavItemOuterWidth(el) {
      if (!el) return 0;
      const style = window.getComputedStyle(el);
      return (
        el.getBoundingClientRect().width +
        (parseFloat(style.marginLeft) || 0) +
        (parseFloat(style.marginRight) || 0)
      );
    },
    scheduleUpdateNavOverflow() {
      if (!process.client) return;
      if (this.navOverflowRaf) {
        cancelAnimationFrame(this.navOverflowRaf);
      }
      this.$nextTick(() => {
        this.navOverflowRaf = requestAnimationFrame(() => {
          this.navOverflowRaf = null;
          this.updateNavOverflow();
        });
      });
    },
    initNavOverflowObserver() {
      if (!process.client || typeof ResizeObserver === "undefined") return;
      this.navResizeObserver = new ResizeObserver(() => {
        this.scheduleUpdateNavOverflow();
      });
      if (this.$refs.navbar) {
        this.navResizeObserver.observe(this.$refs.navbar);
      }
      const container = this.$el?.querySelector?.(".container");
      if (container) {
        this.navResizeObserver.observe(container);
      }
    },
    updateNavOverflow() {
      if (!process.client) return;
      const navbar = this.$refs.navbar;
      const measureList = this.$refs.navbarMeasure;
      if (!navbar || !measureList) return;

      // 移动端导航隐藏时，重置为全部展示，避免切换回桌面时短暂错位
      if (window.innerWidth <= 1024) {
        this.visibleNavCount = this.navLink.length;
        return;
      }

      const availableWidth = navbar.clientWidth;
      if (availableWidth <= 0) return;

      const itemEls = Array.from(
        measureList.querySelectorAll(".nav-item:not(.nav-more)")
      );
      const moreEl = measureList.querySelector(".nav-more--measure");
      const moreWidth = this.getNavItemOuterWidth(moreEl);
      const widths = itemEls.map((el) => this.getNavItemOuterWidth(el));
      const totalWidth = widths.reduce((sum, width) => sum + width, 0);

      if (totalWidth <= availableWidth) {
        this.visibleNavCount = this.navLink.length;
        return;
      }

      let usedWidth = moreWidth;
      let count = 0;
      for (let i = 0; i < widths.length; i++) {
        if (usedWidth + widths[i] <= availableWidth + 0.5) {
          usedWidth += widths[i];
          count += 1;
        } else {
          break;
        }
      }

      // 至少收起 1 项，避免出现「更多」按钮却无内容的情况
      this.visibleNavCount = Math.min(count, Math.max(this.navLink.length - 1, 0));
    },
    /** PC：hover 展开 */
    openStoreDropdownPc() {
      this.storeOpen = true;
      this.isNavMobile = false;
    },
    /** PC：移出关闭 */
    closeStoreDropdownPc() {
      this.storeOpen = false;
    },
    /** 移动端：点击展开/收起 */
    toggleStoreDropdown() {
      this.storeOpen = !this.storeOpen;
      if (this.storeOpen) {
        this.isNavMobile = false;
      }
    },
    handleStoreDocumentClick(event) {
      const pc = this.$refs.storeSelectorPc;
      const mobile = this.$refs.storeSelectorMobile;
      const mobileDropdown = this.$refs.storeDropdownMobile;
      const inPc = pc && pc.contains(event.target);
      const inMobile = mobile && mobile.contains(event.target);
      const inMobileDropdown =
        mobileDropdown && mobileDropdown.contains(event.target);
      if (!inPc && !inMobile && !inMobileDropdown) {
        this.storeOpen = false;
      }
    },
    async fetchStoreSiteData() {
      try {
        const res = await this.$global.getStoreBaseData({
          lang: this.$i18n.locale || "en",
        });
        if (res && Number(res.code) === 0 && res.data) {
          this.storeSiteData = Array.isArray(res.data.storeSiteData)
            ? res.data.storeSiteData
            : [];
        } else {
          this.storeSiteData = [];
        }
      } catch (e) {
        this.storeSiteData = [];
      }
    },
    navTo(item) {
      const query = item.entry ? { entry: item.entry } : {};
      this.$router.push({ path: item.link, query });
      this.isNavMobile = false;
    },
    updateShowFooter(visible) {
      this.showFooter = visible
    },
    applySiteConfigVisibility() {
      this.showNewLogin = this.siteConfig.DialogPassportSwitch == "1"; // 是否显示新版登录框
      this.showFooter =
        this.siteConfig.BottomPassportSwitch == "1" && !this.$store.state.isLogin; // 是否显示底部登录框
      this.showDrawer =
        this.siteConfig.FloatPassportSwitch == "1" && !this.$store.state.isLogin; // 是否显示注册弹窗
      this.showPasswordFree =
        this.siteConfig.NoPwdPassportSwitch == "1" && !this.$store.state.isLogin; // 是否显示免密登录

    },
    handleGlobalAuthRequest() {
      if (this.$store.state.isLogin) return;
      const req = this.$store.state.authModalRequest || {};
      const tab = req.tab === "register" ? "register" : "login";
      const email = req.email || "";
      const modal = this.$refs.authLoginModal;
      if (modal) {
        modal.openDialog(tab, email, req.source || null);
      }
    },
    handleAvatarMouseenter() {
      if (this.isNavMobile) return;
      this.avatarPopover = true;
      this.refreshHeaderPoints();
    },
    async refreshHeaderPoints() {
      if (!this.$store.state.isLogin || !this.$pointsCache) {
        return;
      }

      await this.$pointsCache.ensurePointDetail();
    },
    async loginVerification() {
      if (!process.client) return false;
      if (this.isVerifyingLogin) {
        this.link = this.$route.path;
        return false;
      }
      this.isVerifyingLogin = true;

      try {
        //SSO总站登录校验
        const currentUid = this.$store.state.userInfo?.userInfo?.uid;
        const hasUserInfo = !!currentUid;
        let loginSuccess = this.$store.state.isLogin && hasUserInfo;

        if (hasUserInfo && !this.$store.state.isLogin) {
          this.$store.commit("ISLOGIN", true);
          loginSuccess = true;
        }

        if (
          this.$cookies.get("SSOTOKEN") &&
          this.$cookies.get("lastVerifiedTime") &&
          (this.$store.state.isLogin || hasUserInfo) &&
          hasUserInfo
        ) {
          // 如果cookie中存在SSOTOKEN字段默认代表已登录不做重复总站校验
          // cookie lastVerifiedTime字段 用于时间校验 每10分钟做一次总站校验
          if (
            Math.abs(this.$cookies.get("lastVerifiedTime") - new Date().getTime()) >=
            10 * 60 * 1000
          ) {
            loginSuccess = await this.login();
          }
        } else {
          loginSuccess = await this.login();
        }

        await this.refreshHeaderPoints();
        this.link = this.$route.path;

        if (loginSuccess) {
          await this.handleCmsRedirect();
        }

        return loginSuccess;
      } finally {
        this.isVerifyingLogin = false;
      }
    },
    async handleCmsRedirect() {
      const { source, redirect } = this.$route.query;

      if (source === "cms" && redirect === "/user/xcoins") {
        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          const pointToken = await this.$pointsCache.ensurePointToken();
          if (pointToken) {
            await this.$router.replace("/user/xcoins");
            return;
          }

          if (attempt < maxAttempts) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        }
      }
    },
    async handleGoogleCredential(response) {
      try {
        const res = await this.$global.thirdPartyLogin(
          { third_party_token: response.credential, third_party_type: "3", google_web_push: ["user","fedcm"].includes(response.select_by)?'1':'0'},
          { jumpUrl: window.location.origin + "/user/gallery", lang: this.$i18n.locale || "en" }
        );
        if (res.code == 1) {
          this.$store.commit("SETTOKEN", res.data);
          const result = await this.$global.xfansLogin(res.data);
          this.$cookies.set("SSOTOKEN", res.data.token, { maxAge: 60 * 60 * 24 * 7 });
          this.$cookies.set("lastVerifiedTime", new Date().getTime());
          if (result.code == 1) {
            this.$store.commit("USER_INFO", result.data);
            this.$store.commit("ISLOGIN", true);
            this.$store.state.report = false;
            localStorage.setItem("storeState", JSON.stringify(this.$store.state));
          } else {
            this.$store.commit("SIGNOUT");
            this.$message.warning(this.$t('page.ACCOUNT_RESTRICTED'));
          }
        } else {
          this.$store.commit("SIGNOUT");
        }
      } catch (err) {
        console.error("Google login error:", err);
        this.$store.commit("SIGNOUT");
      }
    },
    async login() {
      try {
        const res = await this.$global.terminusLogin();
        if (res.code != 1) {
          this.$store.commit("SIGNOUT");
          return false;
        }
        this.$store.commit("SETTOKEN", res.data);

        const result = await this.$global.xfansLogin(res.data);

        if (result && result.code == 1) {
          this.$cookies.set("SSOTOKEN", res.data.token, { maxAge: 60 * 60 * 24 * 7 });
          this.$cookies.set("lastVerifiedTime", new Date().getTime());
          this.$store.commit("USER_INFO", result.data);
          this.$store.commit("ISLOGIN", true);
          this.$store.state.report = false;
          localStorage.setItem("storeState", JSON.stringify(this.$store.state));
          return true;
        } else {
          this.$store.commit("SIGNOUT");
          return false;
        }
      } catch (err) {
        console.error("login verification error:", err);
        this.$store.commit("SIGNOUT");
        return false;
      }
    },
    formatHeaderPoints(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number.toLocaleString("en-US") : value || 0;
    },

    searchJump() {
      //跳转到搜索页
      let recentSearch = [];
      if (localStorage.getItem("recentSearch")) {
        recentSearch = JSON.parse(localStorage.getItem("recentSearch"));
        recentSearch.length >= 10
          ? (recentSearch.shift(), recentSearch.push(this.$store.state.searchKeyword))
          : recentSearch.push(this.$store.state.searchKeyword);
      } else {
        recentSearch.push(this.$store.state.searchKeyword);
      }
      localStorage.setItem("recentSearch", JSON.stringify(recentSearch));
      this.inputFocus = false;
      this.$router.push({
        path: "/inquire",
        query: { keyword: this.$store.state.searchKeyword },
      });
    },
    recentSearchJump(item) {
      //历史搜索跳转
      this.inputFocus = false;
      this.$store.state.searchKeyword = item;
      this.$router.push({ path: "/inquire", query: { keyword: item } });
    },
    async searchHistory() {
      //搜索历史
      let res = await this.$global.searchSearch_select();
      res.code == 200 ? (this.searchHistoryArr = res.data) : "";
    },
    async searchSearch_del() {
      //清空搜索记录
      let res = await this.$global.searchSearch_del();
      res.code == 200 ? this.searchHistory() : this.$message.error(this.$t('page.UNKNOWN_ERROR'));
    },

    async signOut(type) {
      //退出登录
      let res = await Promise.all([
        this.$global.logout_syn(),
        this.$global.logout(),
        this.$global.logout_xfans(),
      ]);
      this.signOutDialogVisible = false;
      if (res[0].code == 200 && res[1].code == 200 && res[2].code == 1) {
        this.$cookies.remove("PHPSESSID");
        type == 1 ? this.$router.push("/") : "";
      }
    },
    async getMessageInfo(pageNo = 1) {
      //获取消息数量
      this.loading = true;
      let res = await this.$global.messageLike({ page: pageNo });
      if (res.code == 200) {
        let messageInfo = [];
        for (let key in res.data.get_message) {
          messageInfo.push(res.data.get_message[key]);
        }
        this.$store.commit("MESSAGEINFO", messageInfo);
      }
    },
    reload() {
      //刷新页面
      this.$router.go(0);
    },
    async reportReasons() {
      //投诉
      if (this.$store.state.isLogin) {
        if (!this.checkList.length == 0) {
          let fd = new FormData();
          fd.append("complaint_cont", this.reportTextarea);
          fd.append("complaint_type", this.checkList.join());
          fd.append("complaint_source", this.$store.state.complaint_source);
          fd.append("complaint_source_id", this.$store.state.complaint_source_id);
          let res = await this.$global.complaintAdd(fd);
          res.code == 200 ? this.$message(res.msg) : this.$message.error(res.msg);

          this.$store.commit("CLOSE_REPORT_DIALOG");
          this.reportTextarea = "";
          this.checkList = [];
        } else {
          this.$message({
            message: this.$t('page.PLEASE_ENTER_COMPLETE'),
            type: "warning",
          });
        }
      } else {
        this.$message(this.$t('page.PLEASE_SIGN_IN'));
        this.$store.commit("CLOSE_REPORT_DIALOG");
        this.reportTextarea = "";
        this.checkList = [];
      }
    },
    dialogSize() {
      const apply = () => {
        const { dialogWidth, isMobile } = getDialogSizeByViewport(
          document.body.clientWidth
        );
        this.dialogWidth = dialogWidth;
        this.isMobile = isMobile;
      };
      apply();
      window.onresize = () => {
        this.isNavMobile = false;
        apply();
        this.scheduleUpdateNavOverflow();
      };
    },
    openLoginDialog(payload = {}) {
      if (this.showNewLogin) {
        this.$store.commit("OPEN_AUTH_MODAL", {
          tab: "login",
          redirectToUserCenter: true,
          source: payload.source || "",
        });
        return;
      }
      this.$jumpTerminus(1);
    },
    openRegisterDialog() {
      this.$jumpTerminus(2);
    },
    openForgotPassword(email) {
      if (!this.showNewLogin) {
        this.$jumpTerminus(1);
        return;
      }
      this.$refs.authForgotPasswordModal.openDialog(email);
    },
    openPasswordFree(email) {
      const modal = this.$refs.authFreeLoginModal;
      if (modal) modal.openDialog(email);
    },
    openLoginFromPasswordFree(email) {
      if (!this.showNewLogin) {
        this.$jumpTerminus(1);
        return;
      }
      this.$refs.authLoginModal.openDialog("login", email);
    },
    openLoginFromForgot(email) {
      if (!this.showNewLogin) {
        this.$jumpTerminus(1);
        return;
      }
      this.$refs.authLoginModal.openDialog("login", email);
    },

    jumpRelease(type) {
      this.publishContent = false;

      let routeData = this.$router.resolve({
        path: "/releaseWork",
        query: { type: type },
      });
      window.open(routeData.href, "_blank");
    },
    /** 顶栏发布弹窗：跳转发帖编辑器（新标签页） */
    jumpDiscussionEditor() {
      this.publishContent = false;
      const routeData = this.$router.resolve({ path: "/discussion/editor" });
      window.open(routeData.href, "_self");
    },
    getRecentSearch() {
      //获取最近搜索
      localStorage.getItem("recentSearch")
        ? (this.recentSearch = JSON.parse(localStorage.getItem("recentSearch")))
        : (this.recentSearch = []);
    },
    delRecentSearch() {
      //删除最近搜索
      localStorage.removeItem("recentSearch");
      this.inputFocus = false;
      this.recentSearch = [];
    },


  },
};
